;(function() {
  'use strict'

  angular.module('core.glView', [])
})()
